import { RoleTag } from '../auth-role/auth-role.types';
import { BaseResponseType } from '../cognito/authResponse.types';

export interface SpecificEmployeeResponseDataType {
  todayShifts: number;
  upComingShifts: number;
  swapShifts: number;
  scheduleShiftsHour: number;
  shiftReleased: number;
  subTotal: number;
  totalEarnings: number;
  totalHoursWorked: number;
  tip: number;
  currentTipsPercentage: number;
  previousTipsPercentage: number;
  currentPayPeriod: {
    startDate: Date;
    endDate: Date;
  };
}

export interface SpecificEmployeeResponseType extends BaseResponseType {
  data: SpecificEmployeeResponseDataType;
}

export interface NetSaleType {
  currentAmount: number;
  prev1: number;
  prev2: number;
}
export interface LaborCostType {
  current: number | null;
  prev1: number | null;
  prev2: number | null;
}

export interface ClockedInSummary {
  tag: RoleTag;
  clockedIn: number;
  totalEmployees: number;
}

export interface GuestSummary {
  totalGuests: number;
  seatedGuests: number;
  completedGuests: number;
}

export interface BreakViolations {
  waivedBreak: {
    count?: number;
  };
  missedBreaks: {
    count?: number;
  };
}

export interface DocVaultStats {
  newDocs: number;
  expiringSoon?: number;
}

export interface InventoryStats {
  totalCost: number;
  percentageOfPar: number;
  foodCostPercentageChange: number;
  beverageCostPercentageChange: number;
  ordersCount: number;
  invoicesCount: number;
  latestOrders?: Array<number>;
}

export interface LostAndFoundStats {
  lostAndFoundItems: number;
  retrievedItems: number;
}
export interface OverAllDashboardResponseType extends BaseResponseType {
  data: {
    netSales: NetSaleType;
    laborCost: LaborCostType;
    clockedInSummary: ClockedInSummary[];
    guestSummary: GuestSummary;
    breakViolations: BreakViolations;
    docVaultStats: DocVaultStats;
    lostAndFoundStats: LostAndFoundStats;
    inventoryStats: InventoryStats;
  };
}

export interface StaffResponseType extends BaseResponseType {
  data: {
    conflicts: number;
    overTimes: number;
    poolPending: number;
    timeOffPending: number;
    timeOffMissed: number;
    availabilityUpdates: number;
    pendingDoc: number;
  };
}

export const states = [
  { name: 'Alabama', stateCode: 'AL', config: '{}' },
  { name: 'Alaska', stateCode: 'AK', config: '{}' },
  { name: 'Arizona', stateCode: 'AZ', config: '{}' },
  { name: 'Arkansas', stateCode: 'AR', config: '{}' },
  { name: 'California', stateCode: 'CA', config: '{}' },
  { name: 'Colorado', stateCode: 'CO', config: '{}' },
  { name: 'Connecticut', stateCode: 'CT', config: '{}' },
  { name: 'Delaware', stateCode: 'DE', config: '{}' },
  { name: 'Florida', stateCode: 'FL', config: '{}' },
  { name: 'Georgia', stateCode: 'GA', config: '{}' },
  { name: 'Hawaii', stateCode: 'HI', config: '{}' },
  { name: 'Idaho', stateCode: 'ID', config: '{}' },
  { name: 'Illinois', stateCode: 'IL', config: '{}' },
  { name: 'Indiana', stateCode: 'IN', config: '{}' },
  { name: 'Iowa', stateCode: 'IA', config: '{}' },
  { name: 'Kansas', stateCode: 'KS', config: '{}' },
  { name: 'Kentucky', stateCode: 'KY', config: '{}' },
  { name: 'Louisiana', stateCode: 'LA', config: '{}' },
  { name: 'Maine', stateCode: 'ME', config: '{}' },
  { name: 'Maryland', stateCode: 'MD', config: '{}' },
  { name: 'Massachusetts', stateCode: 'MA', config: '{}' },
  { name: 'Michigan', stateCode: 'MI', config: '{}' },
  { name: 'Minnesota', stateCode: 'MN', config: '{}' },
  { name: 'Mississippi', stateCode: 'MS', config: '{}' },
  { name: 'Missouri', stateCode: 'MO', config: '{}' },
  { name: 'Montana', stateCode: 'MT', config: '{}' },
  { name: 'Nebraska', stateCode: 'NE', config: '{}' },
  { name: 'Nevada', stateCode: 'NV', config: '{}' },
  { name: 'New Hampshire', stateCode: 'NH', config: '{}' },
  { name: 'New Jersey', stateCode: 'NJ', config: '{}' },
  { name: 'New Mexico', stateCode: 'NM', config: '{}' },
  { name: 'New York', stateCode: 'NY', config: '{}' },
  { name: 'North Carolina', stateCode: 'NC', config: '{}' },
  { name: 'North Dakota', stateCode: 'ND', config: '{}' },
  { name: 'Ohio', stateCode: 'OH', config: '{}' },
  { name: 'Oklahoma', stateCode: 'OK', config: '{}' },
  { name: 'Oregon', stateCode: 'OR', config: '{}' },
  { name: 'Pennsylvania', stateCode: 'PA', config: '{}' },
  { name: 'Rhode Island', stateCode: 'RI', config: '{}' },
  { name: 'South Carolina', stateCode: 'SC', config: '{}' },
  { name: 'South Dakota', stateCode: 'SD', config: '{}' },
  { name: 'Tennessee', stateCode: 'TN', config: '{}' },
  { name: 'Texas', stateCode: 'TX', config: '{}' },
  { name: 'Utah', stateCode: 'UT', config: '{}' },
  { name: 'Vermont', stateCode: 'VT', config: '{}' },
  { name: 'Virginia', stateCode: 'VA', config: '{}' },
  { name: 'Washington', stateCode: 'WA', config: '{}' },
  { name: 'West Virginia', stateCode: 'WV', config: '{}' },
  { name: 'Wisconsin', stateCode: 'WI', config: '{}' },
  { name: 'Wyoming', stateCode: 'WY', config: '{}' },
];
